import React from 'react';
import PropTypes from 'prop-types';
import useStyles from '../useStyles';
import { IconButton } from '@mui/material';
import GestureIcon from '@mui/icons-material/Gesture';

function SignatureToggle({ signature, setSignature, userOptions }) {
  const classes = useStyles();

  function handleSignature() {
    signature ? setSignature('') : setSignature(userOptions.signature);
  }

  return (
    <div>
      <IconButton classes={{ root: classes.actionButton }} onClick={handleSignature}>
        <GestureIcon fontSize="small" color={signature ? 'primary' : 'disabled'} />
      </IconButton>
    </div>
  );
}

SignatureToggle.propTypes = {
  signature: PropTypes.string,
  setSignature: PropTypes.func.isRequired,
  userOptions: PropTypes.object.isRequired
};

export default SignatureToggle;
